import React from 'react';
import { mockInvoiceData } from '../../utils/testHelpers';
import { AppConsumer, AppContext } from '../../AppProvider';
import _find from 'lodash/find';
import { withApollo } from 'react-apollo';

import Layout from './DetailLayout';

class InvoiceDetails extends React.Component {
  state = {
    invoice: null
  };

  async componentDidMount() {
    //TODO - once queries are ready, do the query for invoice by ID
    const {
      match: {
        params: { id }
      }

      // client: ApolloClient
    } = this.props;

    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(false);
    setSidebarVisible(false);
    this.setState({
      invoice: _find(mockInvoiceData, ['id', parseInt(id, 10)])
    });
  }

  componentWillUnmount() {
    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(true);
    setSidebarVisible(true);
  }

  render() {
    const { invoice } = this.state;
    return <AppConsumer>{() => <Layout invoice={invoice} />}</AppConsumer>;
  }
}

InvoiceDetails.contextType = AppContext;

export default withApollo(InvoiceDetails);
